module.exports = __webpack_public_path__ + "static/coo-83476d5211e2fd492ad4188d1cfcb015.png";